import React from 'react';
import './ChargingSessionCard.scss';

const ChargingSessionCard = ({ data }) => {
    console.log(data,"data");
  return (
    <div className="charging-card">
      <p className="charging-title">Your all past charging sessions are:</p>
      <div className="charging-info">
        <div className="charging-row">
          <span>Total charging sessions:</span>
          <span className="charging-value">{data.totalSessions}</span>
        </div>
        <div className="charging-row">
          <span>Total amount:</span>
          <span className="charging-value">₹{data.totalAmount}</span>
        </div>
        <div className="charging-row">
          <span>Total units consumed:</span>
          <span className="charging-value">{data.totalUnits}kW</span>
        </div>
        <div className="charging-row">
          <span>Total C2 emissions saved:</span>
          <span className="charging-value">{data.co2Saved}t</span>
        </div>
      </div>
    </div>
  );
};

export default ChargingSessionCard;
